module.exports = __webpack_public_path__ + "static/media/tablet_has_logged_in_icon.ce7dda97.png";